import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "content", "fallback" ]

  replace() {
    this.contentTarget.classList.add("hidden")
    this.fallbackTarget.classList.remove("hidden")
    this.fallbackTarget.classList.add("flex")
  }
}
